module.exports = __webpack_public_path__ + "img/tmc-grey.97d532e.svg";